import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isOpenForgotPwd: false,
  isOpenChangePwd: false,
  isOpenLoginSignupDialog: {
    open: false,
    isLogin: true,
  },
};

const slice = createSlice({
  name: 'authPages',
  initialState,
  reducers: {
    closeForgotPwd(state) {
      state.isOpenForgotPwd = false;
    },
    openForgotPwd(state) {
      state.isOpenForgotPwd = true;
    },
    closeChangePwd(state) {
      state.isOpenChangePwd = false;
    },
    openChangePwd(state) {
      state.isOpenChangePwd = true;
    },
    openLoginSignup(state, action) {
      state.isOpenLoginSignupDialog = {
        open: action?.payload?.open,
        isLogin: action?.payload?.isLogin,
      };
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { openForgotPwd, openChangePwd, closeForgotPwd, closeChangePwd, openLoginSignup } = slice.actions;
